import { useState } from 'react';

import { useLocation, useParams } from 'react-router-dom';

import { useMutationUpdateRiskRegister } from 'api/mutations/UpdateRiskRegister.mutation';
import { useQueryGetRisk } from 'api/queries/getRisk.query';

import { RiskRegisterFormTabs } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Tabs/Tabs.utils';

export const useUpdateRiskRegisterFormProvider = () => {
    const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
    const { riskId } = useParams<{ riskId: string }>();
    const { hash } = useLocation();
    const [activeTab, setActiveTab] = useState<RiskRegisterFormTabs>(
        hash ? (hash.replace('#', '') as RiskRegisterFormTabs) : 'details',
    );
    return {
        ui: {
            state: {
                activeTab,
                showConfirmModal,
            },
            setters: {
                setActiveTab,
                setShowConfirmModal,
            },
        },
        api: {
            getRisk: useQueryGetRisk({ riskId }),
            updateRisk: {
                instance: useMutationUpdateRiskRegister(),
            },
        },
    };
};
